import { LinkUtils } from '@atlassian/mpac-utils';
import { connect } from 'react-redux';

import * as analytics from 'common/utils/analytics/analytics';
import commonMapDispatchToProps from '../../../../../../../container/commonMapDispatchToProps';
import commonMapStateToProps from '../../../../../../../container/commonMapStateToProps';
import { openSubscribeDialog } from '../../../../../../common/SubscribeMailingListDialog/action/SubscribeMailingListActions';
import AddonDiscoveryWrapper from '../components/AddonDiscoveryWrapper';

function mapStateToProps(state: any) {
  return {
    ...commonMapStateToProps(state),
    config: state.addonDiscovery.config,
    solutionsConfig: state.solutions.config,
  };
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    ...commonMapDispatchToProps(dispatch),
    onSubscribeToMailingListClicked: () => dispatch(openSubscribeDialog()),
  };
};

const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onCategoryTileClick: (event, { category, href }) => {
      analytics.trackCategoryTileClicked(category);
      LinkUtils.maybeOpenInNewTab(event, () => {
        ownProps.history.push({ pathname: href });
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AddonDiscoveryWrapper);
